import "./DownloadCenter.module.css";
import NavigationBar from "@/reusable_sections/Header";
import CoreGrowthSolutions from "./sections/CoreGrowthSolutions";
import EcosystemFaq from "./sections/EcosystemFaq";
import FooterInformation from "@/reusable_sections/Footer";
export default function DownloadCenterPage() {
  return <div>
      <NavigationBar />
      <CoreGrowthSolutions />
      <EcosystemFaq />
      <FooterInformation />
    </div>;
}